module.exports = __webpack_public_path__ + "static/media/semarion.c0ae972a.png";